import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';

export default class DocumentUploadAbility extends Ability {
  @service declare state: StateService;
  @service declare featureFlags: FeatureFlagsService;

  get canAccess(): boolean {
    if (!this.state.vrSubscription?.canAccessPreregDocumentUpload) return false;
    if (!this.featureFlags.isEnabled('vis-prereg-document-uploads')) return false;

    return true;
  }
}
